
    jQuery(document).ready(function ( $) {
    $('.close-button').on('click', function () {
      
      $('.menu-drawer-container').toggleClass('menu-opening');
      $('body').removeClass(' overflow-hidden-desktop');
       $('div').removeClass('menu-open');
    });
  });

  jQuery(document).ready(function($) {
  jQuery('#menu-drawer .close-button').on('click', function() {
    setTimeout(function() {
      jQuery('summary[aria-expanded="true"]').attr('aria-expanded', 'false');
    }, 100); 
  });
});
  

jQuery(document).ready(function($) {
  $(".header header-menu details").on("mouseover", function () {
    $(this).attr("open", true);
  }).on("mouseleave", function () {
    $(this).removeAttr("open");
  });
});


// jQuery(document).ready(function ($) {
//   if ($(window).width() >= 992) {
//   $(".menu-drawer__menu details").hover(
//     function () {
//       // mouseenter: open submenu
//       $(this)
//         .addClass("menu-opening")
//         .attr("open", true)
//         .find("summary")
//         .attr("aria-expanded", true);
//     },
//     function () {
//       // mouseleave: close submenu
//       $(this)
//         .removeClass("menu-opening")
//         .removeAttr("open")
//         .find("summary")
//         .removeAttr("aria-expanded");
//     }
//   );
// }
// });


jQuery(".menu-drawer__menu.has-submenu.list-menu li details div.menu-drawer__submenu .menu-drawer__inner-submenu ul.menu-drawer__menu.list-menu details").each(function(){
   var v =  jQuery(this).find(".menu-drawer__submenu").find("ul").html();
    jQuery("<div class='li-wrapper'><ul> "+ v  + "</ul></div>").appendTo(jQuery(this).find("summary"));
})




// jQuery(document).ready(function() {

//   function updateCurrencyDisplay() {
//     var selectedCountry = $('select.currency-switcher option:selected').data('country');
    
//     if (selectedCountry === 'Australia') {
//       $('.money').each(function() {
//         var text = $(this).text();
//         var newText = text.replace(/\s*AUD\s*/g, '').trim();
//         $(this).text(newText);
//       });
//     } else {
//       $('.money').each(function() {
//         var audValue = $(this).attr('doubly-currency-aud') || '';
//         if (audValue) {
//           $(this).text('$' + (audValue/100).toFixed(2) + ' AUD');
//         }
//       });
//     }
//   }
//  setTimeout(function() {
//   console.log("ASAsS");
//   updateCurrencyDisplay();
//  }, 500); 

//   $('select.currency-switcher').on('change', function() {
//   setTimeout(updateCurrencyDisplay, 500);
// });
// });

//Jquery to add Read More and Read Less button on collection description





// jQuery(function($){
//   var $container = $('.collection-hero__description.rte');
//   if (!$container.length) return;

//   var fullText = $container.text().trim();
//   if (!fullText.length) return;

//   // Rough estimate: number of characters per line
//   var charsPerLine = Math.floor($container.width() / 8); // adjust divisor (8) based on font size
//   var maxLines = 3;
//   var maxChars = charsPerLine * maxLines;

//   if (fullText.length <= maxChars) return; // text short, no need for button

//   // Cut text safely at word boundary
//   var shortText = fullText.substr(0, maxChars);
//   shortText = shortText.substr(0, Math.min(shortText.length, shortText.lastIndexOf(" ")));

//   // Create new HTML
//   var html = `<span class="short-text">${shortText}...</span><span class="full-text" style="display:none;">${fullText}</span> 
//     <a href="#" class="read-more-btn" aria-expanded="false" style="font-weight:600;">READ MORE</a>`;
  
//   $container.html(html);

//   // Handle toggle
//   $container.on('click', '.read-more-btn', function(e){
//     e.preventDefault();
//     var $btn = $(this);
//     var expanded = $btn.attr('aria-expanded') === 'true';

//     if (!expanded) {
//       $container.find('.short-text').hide();
//       $container.find('.full-text').show();
//       $btn.text('READ LESS').attr('aria-expanded', 'true');
//     } else {
//       $container.find('.short-text').show();
//       $container.find('.full-text').hide();
//       $btn.text('READ MORE').attr('aria-expanded', 'false');
//     }
//   });
// });

// jQuery(function ($) {
//   var $container = $('.collection-hero__description.rte');
//   if (!$container.length) return;

//   var fullHtml = $container.html().trim();
//   if (!fullHtml.length) return;

//   var maxChars = 250;

//   function truncateHtml(html, limit) {
//     var div = document.createElement('div');
//     div.innerHTML = html;
//     var count = 0;

//     function walk(node) {
//       if (count >= limit) {
//         node.remove();
//         return;
//       }

//       if (node.nodeType === 3) {
//         var remaining = limit - count;
//         if (node.nodeValue.length > remaining) {
//           node.nodeValue = node.nodeValue.substring(0, remaining) + '...';
//           count = limit;
//         } else {
//           count += node.nodeValue.length;
//         }
//       } else if (node.nodeType === 1) {
//         Array.from(node.childNodes).forEach(walk);
//       }
//     }

//     walk(div);
//     return div.innerHTML;
//   }

//   var plainText = $('<div>').html(fullHtml).text().trim();
//   if (plainText.length <= maxChars) return;

//   var shortHtml = truncateHtml(fullHtml, maxChars);

//   var html = `
//     <div class="short-text">${shortHtml}</div>
//     <div class="full-text" style="display:none;">${fullHtml}</div>
//     <div class="read-more-wrap">
//       <a href="#" class="read-more-btn" aria-expanded="false">
//         READ MORE <span class="arrow"></span>
//       </a>
//     </div>
//   `;

//   $container.html(html);

//   $container.on('click', '.read-more-btn', function (e) {
//     e.preventDefault();
//     var $btn = $(this);
//     var expanded = $btn.attr('aria-expanded') === 'true';

//     if (!expanded) {
//       $container.find('.short-text').hide();
//       $container.find('.full-text').show();
//       $btn.html('READ LESS <span class="arrow"></span>')
//           .attr('aria-expanded', 'true');
//     } else {
//       $container.find('.short-text').show();
//       $container.find('.full-text').hide();
//       $btn.html('READ MORE <span class="arrow"></span>')
//           .attr('aria-expanded', 'false');
//     }
//   });
// });


// jQuery(function ($) {
//   var $container = $('.collection-hero__description.rte');
//   if (!$container.length) return;

//   var fullHtml = $container.html().trim();
//   if (!fullHtml.length) return;

//   var maxChars = 300;

//   function truncateHtml(html, limit) {
//     var div = document.createElement('div');
//     div.innerHTML = html;
//     var count = 0;

//     function walk(node) {
//       if (count >= limit) {
//         node.remove();
//         return;
//       }

//       if (node.nodeType === 3) {
//         var remaining = limit - count;
//         if (node.nodeValue.length > remaining) {
//           node.nodeValue =
//             node.nodeValue.substring(0, remaining) + '...';
//           count = limit;
//         } else {
//           count += node.nodeValue.length;
//         }
//       } else if (node.nodeType === 1) {
//         Array.from(node.childNodes).forEach(walk);
//       }
//     }

//     walk(div);
//     return div.innerHTML;
//   }

//   var plainText = $('<div>').html(fullHtml).text().trim();
//   if (plainText.length <= maxChars) return;

//   var shortHtml = truncateHtml(fullHtml, maxChars);

//   var shortHtmlWithBtn = shortHtml.replace(
//     /<\/p>\s*$/,
//     ` <span class="read-toggle-inline">
//         <a href="#" class="read-toggle-btn" data-state="more">READ MORE</a>
//       </span></p>`
//   );

//   var fullHtmlWithBtn = `
//     ${fullHtml}
//     <p>
//       <span class="read-toggle-inline">
//         <a href="#" class="read-toggle-btn" data-state="less">READ LESS</a>
//       </span>
//     </p>
//   `;

//   var finalHtml = `
//     <div class="short-text">
//       ${shortHtmlWithBtn}
//     </div>

//     <div class="full-text" style="display:none;">
//       ${fullHtmlWithBtn}
//     </div>
//   `;

//   $container.html(finalHtml);
//   $container.on('click', '.read-toggle-btn', function (e) {
//     e.preventDefault();
//     var state = $(this).data('state');

//     if (state === 'more') {
//       $container.find('.short-text').hide();
//       $container.find('.full-text').show();
//     } else {
//       $container.find('.full-text').hide();
//       $container.find('.short-text').show();
//     }
//   });
// });

// Start observing when DOM is ready
// document.addEventListener('DOMContentLoaded', function() {
//   const productGridContainer = document.getElementById('ProductGridContainer');
//   if (productGridContainer) {
//     observer.observe(productGridContainer, {
//       childList: true,
//       subtree: true
//     });
//   }
//   initReadMoreToggle();
// });

//filter-toggle
$('.filter-button-toggle').click(function(){
    $(this).next().toggleClass("showFilter");
}); 



jQuery("details.js-filter").each(function() {
  // Get the label text inside this filter
  let text = jQuery(this).find('.facets__summary-label')
                .clone()
                .children()
                .remove()
                .end()
                .text()
                .trim();

  // Check if the filter is Brand or Product Type OR if it's currently closed
  let isClosed = jQuery(this).find("summary").attr("aria-expanded") === "false";

  if (text === "Brand" && isClosed || text === "Product Type" && isClosed) {
    jQuery(this).find("summary").trigger("click"); // simulate click to open
  }
});



jQuery(document).on("click", "nav.menu-drawer__navigation summary.menu-drawer__menu-item", function (e) {
    // If user clicks a link inside summary, don't toggle the dropdown
    if (jQuery(e.target).is("a")) {
        return true; // allow normal link click
    }

    e.preventDefault(); // stop default toggle

    var $details = jQuery(this).closest("details");
    var isOpen = $details.attr("open") !== undefined;

    // Close all others
    jQuery("nav.menu-drawer__navigation details.main-details")
        .removeAttr("open")
        .find("summary")
        .attr("aria-expanded", "false");

    // If already open, just close and return
    if (isOpen) {
        $details.removeAttr("open");
        jQuery(this).attr("aria-expanded", "false");
        return;
    }

    // Open clicked one
    $details.attr("open", "open");
    jQuery(this).attr("aria-expanded", "true");
});




// if(jQuery("body").hasClass("collection")){
// $(function () {
//     const url = new URL(window.location.href);

//     // Step 1: Remove all duplicate sort_by before setting new one
//     url.searchParams.delete("sort_by");

//     // Step 2: Add default sorting (last option)
//     url.searchParams.set("sort_by", "created-descending");

//     // Step 3: Update select dropdown (UI)
//     const sortSelect = document.getElementById("SortBy");
//     if (sortSelect) {
//         sortSelect.value = "created-descending";

//         // Fire **native** change event (Shopify needs this)
//         sortSelect.dispatchEvent(new Event("change", { bubbles: true }));
//     }

//     // 💡 Don't reload page again if already correct
//     if (window.location.href !== url.toString()) {
//         window.location.href = url.toString();
//     }
// });

// }